import { render, staticRenderFns } from "./BackofficeRightNavBar.vue?vue&type=template&id=1ff3ad7e"
import script from "./BackofficeRightNavBar.vue?vue&type=script&lang=ts"
export * from "./BackofficeRightNavBar.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeRightNavBar.vue?vue&type=style&index=0&id=1ff3ad7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports